import type { ReactNode } from 'react'
import { ChevronDown, ChevronUp } from 'baseui/icon'
import PulseCollapse from '@/shared/components/PulseScope/PulseCollapse'
import useCollapsibleProducts from './useCollapsibleProducts'
import {
  CollapsibleBody,
  CountPill,
  PanelGroup,
  ProductList,
  SectionChevron,
  SectionHeader,
  SideTitle,
} from './styled-components'

interface CollapsibleProductsProps {
  id: string
  label: string
  count: number
  initiallyOpen: boolean
  forceOpen: boolean
  children: ReactNode
}

const CollapsibleProducts = ({ id, label, count, initiallyOpen, forceOpen, children }: CollapsibleProductsProps) => {
  const { isOpen, toggle } = useCollapsibleProducts(initiallyOpen, forceOpen)

  if (count === 0) return null

  return (
    <PanelGroup>
      <SectionHeader type='button' aria-expanded={isOpen} aria-controls={id} disabled={forceOpen} onClick={toggle}>
        <SideTitle $as='span'>{label}</SideTitle>
        <CountPill>{count}</CountPill>
        <SectionChevron>
          {isOpen ? <ChevronUp size={20} color='currentColor' /> : <ChevronDown size={20} color='currentColor' />}
        </SectionChevron>
      </SectionHeader>
      <CollapsibleBody>
        <PulseCollapse open={isOpen} scrollOnOpen={false}>
          <ProductList id={id}>{children}</ProductList>
        </PulseCollapse>
      </CollapsibleBody>
    </PanelGroup>
  )
}

export default CollapsibleProducts
